import { shipmentStatuses, shipmentStatusLabels } from '@reveni-io/reveni-ui'

export const getShipmentStatusOptions = () =>
  Object.values(shipmentStatuses).map(value => ({ value, label: shipmentStatusLabels[value] }))
